import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsXrpComponent } from './simple-icons-xrp.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsXrpComponent ],
    exports:      [ SimpleIconsXrpComponent ],
    bootstrap:    []
})
export class SimpleIconsXrpModule {}
